
export default {
    login_signup: '로그인 / 등록',
    currency: '통화 선택',
    tofficial_platform: '유일한 HSK 공식 모의시험 플랫폼',
    proficiency_tests: '세계에서 가장 인기 있는 중국어 능력 시험을 준비하세요',
    get_started: '시작',
    use_pc_or_app: '지금 체험하려면 컴퓨터로 로그인하거나 앱을 다운로드하세요.',
    pay_tip: '알리페이(Alipay) 또는 위챗페이(WeChat Pay)를 통해 모의시험지를 구매한 경우, 중국 본토 서비스 웹사이트 hskmock.cn을 이용하세요.',
    platform_china: '이 플랫폼은 중국 본토의 수험생에게도 지원을 제공합니다.',
    international_platform: '중국 플랫폼은 중국 본토에 있으며, 국제 플랫폼은 싱가포르에 있습니다. 두 플랫폼은 독립적이므로, 적합한 플랫폼을 선택하세요.',
    take_confidence: 'HSK 시험에서 성공을 거두세요',
    practice_tests: 'HSK 및 YCT 실전 연습',
    using_time: '중국어 공식 주관사 제공 최신기출문제를 사용하여 다양한 문제 유형에 익숙해지고, 시험 요구 사항을 숙지하며, 답을 선택하는 속도를 향상시키고, 성공적으로 시험에 응시하세요.',
    instant_results: '즉시 피드백 받기',
    each_test_question: '응시완료 후 각 문제를 다시 선택하면 점수 확인 및 문제별 해설, 정답도 확인할 수 있습니다. 자신의 성적을 파악하고, 부족한 부분을 보완하여 목표 점수에 도달해보세요.',
    track_progress: '진행 상황 기록',
    ready_next_test: '플랫폼은 각 모의시험의 날짜와 시간, 기술 향상 및 성적 변화를 자동으로 기록합니다. 이 기록은 실제 시험에 응시할 최적의 시점을 알려주며, 그 시점에 최고의 결과를 얻을 수 있습니다.',
    receive_official_certificates: '공식 인증서 받기',
    certificates_provide_evidence: '합격한 모든 모의시험에 대해 인증서를 발급합니다. 이 인증서는 일정 레벨의 중국어 능력을 증명합니다.',
    ready_next_level: '다음 단계 시작',
    check_description: '다음 단계의 지침을 검토하여 목표를 명확히 하세요. 시험 요구 사항 및 규칙을 재확인하고, 규정된 어휘를 복습하며, 시험 내용을 미리 보고, 시험 스킬을 익히세요.',
    on_the_move: '모바일 사용?',
    download_mobile: '아래 버튼을 클릭하여 모바일 앱을 다운로드하세요.',
    hsk_beginner_advanced: "<span style='font-weight: 700'>HSK</span>는 '중국어 능력 평가 시험'의 병음 약자입니다. 전세계에서 가장 인기 있는 중국어 능력 시험으로, 초급부터 고급까지 총 9단계가 있습니다.",
    more: '더 보기 >',
    ytc_beginner_advanced: "<span style='font-weight: 700'>YCT</span>는 '청소년 중국어 능력 평가 시험'의 약자로, 청소년을 위한 중국어 능력 시험입니다. 초급부터 중급까지 총 4단계가 있습니다.",
    coming_end: '2023년 말에 구술 모의시험이 출시됩니다',
    level_oral_tests: "<span style='font-weight: 700'>HSKK</span>는 '중국어 레벨 말하기 시험'의 약자입니다.",
    help_students_for_testing: '학생들이 시험을 준비하도록 돕고 있나요?',
    help_students_for_testing_desc: '교사는 학생들이 다음 시험 목표를 달성하는 데 중요한 역할을 합니다. <br>교사가 학생들에게 개인화된 학습 지원을 제공할 수 있도록 도와주세요.',
    teacher: '교사',
    become_partner: '현지 파트너가 되세요',
    become_partner_desc: '응시자는 모국어로 지역 시험 센터에 문의하고, 선호하는 현지 결제 방법으로 결제할 수 있습니다.',
    partnership: '협력 탐색',
    check_test_dates: '시험 날짜 확인',
    book_test: '시험 등록',
    about_us: '우리에 대해',
    level: '레벨',
    feedback: '문의하기',
    tos_link: '서비스약관',
    privacy_link: '개인정보처리방침',
    level_title: '당신의 목표 레벨은 무엇인가요?',
    // level_des: '확실하지 않은 경우, <b style="color: #000; cursor: pointer; font-weight: 700;" class="clickable">무료 레벨 자가 진단 > </b>을 이용해 보세요.',
    level_BEGINNER: '초급',
    level_INTERMEDIATE: '중급',
    level_ADVANCED: '고급',
    Pick_your_level: '레벨 선택',
    Take_practice_test: '모의시험',
    About_this_level: '레벨 소개',
    unit_price: '{price}/번 테스트',
    test_total_question: '총 {count}문제',
    my_homework_time_full: '{min}분',
    use_code: '쿠폰코드 사용',
    hsk_buy: '구매',
    hsk_start_exam: '시험 시작',
    hsk_go_on: '시험 계속',
    test_has_practiced: '연습 결과 보기',
    product_code: '쿠폰코드',
    enter_paper: '테스트에 참여하려면 쿠폰코드 를 입력하세요.',
    code_here: '여기에 쿠폰코드를 입력하세요.',
    no_code: '쿠폰코드가 없으신가요? 파트너에게서 구매하세요:',
    to_partner: '파트너 링크로 이동',
    waiting_pay: '결제 대기 중...',
    pay_failed: '페이지가 제대로 연결되지 않나요?',
    common_text_server_error: '다시 시도해 보세요',
    pay_un_finished: '결제를 완료할 수 없습니다.',
    pay_callback_tips: '중국 본토에 있으나 중국 시민이 아닌 경우, Visa 또는 Master카드를 사용하는 것을 권장합니다. WeChat, Alipay, UnionPay 카드 지원 솔루션 개발중입니다.',
    choose_method: '잠금 해제 방법 선택',
    choose_new_method: '새 테스트를 잠금 해제할 방법을 선택하세요.',
    practice_test: '시험 연습에 참여하기',
    Learning_resources: '학습 자료',
    Compare_syllabuses_a: '다른 과정과 HSK 강의계획서 비교',
    Not_sure: '자신의 레벨이 궁금하신가요?',
    free_level_test: '무료 레벨 자가 진단 응시',
    listening_section: '듣기 부분',
    hsk_point: '점수',
    hsk_part1: '제 {part} 부분',
    reading_section: '독해 부분',
    writing_section: '쓰기 부분',
    Examples: '예제',
    vocab_total_item: '총 {total}개',
    vocab_search: '한자/병음/번역 검색',
    test_all: '전체',
    vocab_already_marked: '표시됨',
    vocab_unmarked: '표시되지 않음',
    vocabulary: '단어',
    vocab_pinyin: '병음',
    vocab_translate: '번역',
    the_level: '등급',
    vocab_mark: '표시',
    mark_back: '돌아가기',
    Compare_syllabuses: '개요와 비교',
    table_shows_syllabuses: '이 표는 서로 다른 HSK 레벨의 개요를 보여줍니다.',
    forrgin_lang: '0547은 "중국어를 외국어로"',
    Second_Language: '0523은 "중국어를 제2언어로"',
    Requirement_entry: '등록 조건',
    most_Chinese_universities: '대부분의 중국 대학',
    Qing_Hua: '칭화대',
    beijing_university: '베이징대',
    level_dialog_content: '무료 레벨 자가 진단은 약 15분이 소요되며, 결과는 현재 HSK 레벨과 네 가지 언어 능력(듣기, 독해, 쓰기, 말하기)에 대해 해당 레벨에 얼마나 가까운지를 보여줍니다.',
    level_dialog_start: '레벨테스트 시작',
    working_towards: '테스트 후 다음을 준비하는 것이 좋습니다.',
    hsk_listen_name: '듣기',
    hskk_listen_name: '스피커 및 마이크 테스트',
    spc_speak: '말하기',
    hsk_read_name: '독해',
    hsk_write_name: '쓰기',
    Retake_level_test: '재시험',
    students_forward: '학생 지원',
    try_it_out: '지금 체험하기',
    walk_through: '시험 절차 숙지',
    teachers_page_desc1: '플랫폼 기능은 학급 수업뿐만 아니라 1대1 수업에도 적합합니다. 학생들이 다양한 유형의 문제에 익숙해지고, 지정된 단어를 복습하며, 시험 내용을 미리 보고, 시험 기술을 습득할 수 있도록 돕습니다.',
    assign_practice_papers: '학생 제출 마감일 및 시간 설정',
    teachers_page_desc2: '시험지를 학생들에게 배포하십시오. 이 모의시험을 실제 시험처럼 사용할 수 있으며, 학생들이 HSK 시험의 다양한 문제 유형에 익숙해질 수 있도록 도와줍니다.',
    get_instant_results: '즉각적인 성적 피드백',
    teachers_page_desc3: '교사가 수동으로 시험지를 채점할 필요가 없습니다. 학급 학생들이 지정된 시험지를 완료했는지 확인하고, 각 시험의 성적을 확인하세요.',
    review_their_answers: '학생 응시 상황을 검토',
    teachers_page_desc4: '학급별, 기술별, 파트별, 문제별로 학생의 시험 성적을 자세히 검토할 수 있습니다. 학생의 응시 상황을 검토하여, 학생에게 정확한 교육 계획을 수립하고 맞춤형 피드백을 제공합니다.',
    track_prog: '학생 진행 상황 추적',
    teachers_page_desc5: '학생의 모든 시험 성적이 자세히 기록되며, 시험지의 각 문제에 대한 응답 상황과 기술 향상 및 성적 변화를 보여줍니다. 이러한 기록은 학생이 실제 시험을 치러야 할 적절한 시기를 알려주며, 최고의 성적을 거둘 수 있도록 도와줍니다.',
    students_next_level: '학생의 레벨을 한단계 UP 시켜주세요.',
    teachers_page_desc6: '우리의 합력 플랫폼은 공식 HSK 및 YCT 교재와 여러분이 필요로 하는 교육 도구와 자원을 제공하여 교사가 학생에게 맞춤형 학습 지원을 제공할 수 있도록 합니다.',
    teaching_resources: '**교육 자료**',
    teachers_desc1: '개인 계정으로 HSK Mock 모의시험 플랫폼에 <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">로그인</span>해 주십시오.',
    teachers_desc2: '아래에 기본 정보를 입력해 주시면, 학교에 대한 무료 체험을 제공해 드리겠습니다.',
    school_name: '학교 이름',
    school_web: '학교 웹사이트',
    num_of_hsk_teachers: 'HSK 교사 수',
    num_of_hsk_learners: 'HSK 학생 수',
    add_msg: '메시지를 보내 주세요',
    contact_style: '어떻게 연락드릴까요?',
    send: '전송 클릭',
    home_page: '홈페이지',
    partner_title1: '파트너가 되시길 바랍니다',
    partner_title2: '현지 파트너가 되십시오',
    partner_forms_desc: '우리의 현지 파트너가 되어, 귀하의 국가 또는 지역에서 시험 응시자, 교사, 초중고 및 대학의 주요 연락 담당자가 되어 주세요.<br><br>현지 파트너는 일반적으로 성숙한 HSK 시험 및 교육 센터로, 비즈니스 규모를 확장하고 공식 인정을 향상시키기를 희망합니다.<br><br>현지 파트너가 되기를 원하신다면, 개인 HSK 모의 계정으로 <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">로그인</span>하고 아래 정보를 입력해 주세요. 저희가 곧 연락 드리겠습니다.',
    company_name: '회사 이름',
    company_website: '회사 웹사이트',
    teachers_count: '협력하는 HSK 교사의 수',
    learners_count: '협력하는 HSK 학생의 수',
    about_us_first_paragraph: '<b>HSK Mock</b>은 세계에서 가장 인기 있는 중국어 능력 시험인 HSK와 YCT의 유일한 공식 모의시험 플랫폼입니다. 이 플랫폼은<b>한고국제</b>와 <b>Wo Hui Mandarin</b>의 협력 제품입니다.',
    about_us_second_paragraph: '<b>한고국제</b> (CTI)는 HSK와 YCT의 주관사입니다. 이들은 베이징에 본사를 둔 유한책임회사로, 개인 및 기관을 위한 다양한 서비스를 제공하며, 전 세계적으로 중국어를 외국어로서 학습, 교육 및 평가를 촉진하고 지원합니다.',
    about_us_cti_text: '자세히 알아보기',
    about_us_third_paragraph: '<b>Wo Hui Mandarin</b> (우회)는 HSK와 YCT 코스 및 시험의 공식 온라인 플랫폼을 제공합니다. 이들은 싱가포르에 본사를 둔 유한책임회사로, 기술을 통해 학습을 학생의 손에 해방시키며, 교사가 학생의 개인 학습 여정에서 필요한 지원을 제공할 수 있도록 권한을 부여합니다.',
    about_us_wohui_text: '더 자세히 알고 싶다면, 다음을 참조해 주세요.',
    please_enter_content: '피드백을 입력하세요 (필수)',
    describe_detail: '문제를 설명할 경우, 가능한 한 상세한 정보를 제공해 주세요.',
    upload_picture: '사진 업로드 (선택 사항, 최대{maxFiles}장. JPG/PNG 지원, 각 이미지 크기 2M 이하)',
    button_common_hand_in: '제출',
    email_address: '이메일 주소',
    forget_pw: '비밀번호를 잊으셨나요',
    sign_up_privacy: '<a class="link" target="_blank" rel="noopener noreferrer" href="{url}">이용 약관</a> 및 <a class="link" target="_blank" rel="noopener noreferrer" href="{userUrl}">개인정보 보호정책</a>을 읽고 동의했습니다.',
    continue: '계속하기',
    complete_profile: '개인 프로필 작성',
    verify_email: '이메일 인증',
    link_sent: '등록해 주셔서 감사합니다. 보내드린 링크를 클릭하여 올바른 이메일 주소인지 확인해 주십시오:',
    resend_link: '링크 다시 보내기 >',
    email_verified: '이메일이 인증되었습니다!',
    thank_you: '감사합니다!',
    or_return: '또는 프로그램으로 돌아가기',
    parental_consent: '부모님의 동의',
    sent_parental: '등록해 주셔서 감사합니다. 이메일로 보내드린 지침에 따라 부모님 또는 보호자의 동의를 받아 주세요:',
    resend_email: '메일 다시 보내기',
    child_profile: '자녀의 개인정보',
    email: '이메일',
    request_email: '위 정보(이메일 주소 제외)는 로그인 후에도 업데이트할 수 있습니다. 자녀가 계정을 생성하는 데 동의해 주시기 바랍니다. 그렇지 않으면 자녀의 정보를 삭제해 달라고 요청해 주십시오.',
    give_consent: '동의합니다',
    delete_child_details: '자녀의 정보 삭제',
    account_created: '계정 생성',
    emailed_know: "이메일<span style='font-weight: 700'>{email}</span>로 안내 메일을 발송했습니다.",
    account_deleted: '계정 삭제',
    child_know_deleted: '자녀에게 정보를 삭제했다는 사실을 알려 주세요.',
    my_account: '내 계정',
    firstName: '이름',
    lastName: '성',
    birthday: '생년월일',
    gender: '성별',
    male: '남성',
    female: '여성',
    non_disclosure: '비공개',
    country: '국적',
    preferred_currency: '선호 통화',
    parent_guardian: '부모님/보호자',
    save: '저장',
    button_common_cancel: '취소',
    my_class_name: '내 학급',
    class_name: '학급명',
    change_pw: '비밀번호 변경',
    cancel_delete_account: '계정 로그아웃',
    learn_history: '학습 기록',
    tests: '시험 기록',
    hsk_finished: '완료된 시험지',
    test_paper: '시험지',
    total_score: '총점',
    my_homework_assignment_certificate: '증명서',
    recharge_log: '구매 기록',
    consume_time: '소비 시간',
    recharge_method: '결제 방식',
    no_test: '수량',
    my_class_all_class: '전체 학급',
    my_homework_paper: '시험지 이름',
    my_homework_stu_sent_by: '보낸 사람',
    edit_message_Send_time: '보낸 시간',
    my_homework_due_on: '마감 시간',
    my_homework_delay_hint: '지정된 마감일과 시간 이후에 학습자가 과제를 제출할 수 있도록 허용할지 표시',
    my_homework_add_note: '비고 내용',
    evaluate_common_total_score: '점수',
    sure_change_lang: '언어를 변경하시겠습니까?',
    button_common_ok: '확인',
    hint_common_wait_loading: '리소스 다운로드 중...',
    spc_test_content: '테스트 내용',
    hsk_test_num: '문제 수',
    hsk_total_num: '총 문제 수',
    hsk_test_time: '시험 시간',
    hsk_time_total: '총 시간',
    hsk_test_ready: '시험 전 준비',
    hsk_test_ready_tips: '이 시험지는 듣기 부분을 포함하고 있으니, 미리 재생 장치를 조정해 주세요. 듣기시험이 곧 시작됩니다.',
    hsk_preview_listen_msg: '지금 시험 설명을 재생합니다. 이 기간 동안 듣기 각 부분의 문제 번호를 클릭하여 문제를 미리 볼 수 있습니다.',
    hsk_preview_listen_prompt: '지금 시험 설명을 재생합니다. 이 기간 동안 듣기 각 부분의 문제 번호를 클릭하여 문제를 미리 볼 수 있습니다. 시험 중에는 페이지를 새로 고치거나 닫지 마십시오. 그렇지 않으면 답안 데이터가 손실될 수 있습니다.',
    cancel_delete_ok: 'OK',
    hsk_example: '예시',
    review_answers: '답안 확인',
    hsk_left_time: '시험 남은 시간',
    hsk_submit_listen: '듣기 제출',
    hsk_submit_paper: '시험지 제출',
    hsk_submit_msg: '시험지를 제출하시겠습니까?',
    hsk_report: '성적 결과',
    hsk_qualified_point: '{points}점 합격',
    get_official_mock_certificate: '공식 모의 증명서 획득',
    click_tips: '문제 번호를 클릭하여 답안을 확인하세요',
    hsk_right_rate: '정확도',
    hsk_accuracy1: '정확률',
    certificate_details: '증명서 세부 정보',
    certificate_tips: '증명서 세부 정보는 귀하의 개인 정보에서 가져옵니다. 정확한지 확인해 주세요:',
    email_to: '증명서는 이메일로 전송됩니다:',
    pay_discount_title: '{level}의 공식 모의시험을 몇 번 구매하시겠습니까?',
    my_class_total: '총계',
    test_pay: '결제',
    price_desc: '공식 모의시험 비용만 지불하시면 됩니다. 여러 번 구매하시면 단일 시험에 대해 할인이 적용됩니다.',
    discounted_price: '가격',
    price_contact_us: '학교와 기관을 위한 대량 구매 서비스도 제공합니다. 구체적인 요구 사항에 대해 <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">문의해 주세요</span>.',
    get_a_discount: '할인 받기',
    finished_pay_discount_title: '다음은 {level_name} 공식 모의시험지의 쿠폰코드입니다.',
    btn_goto_papers: '{level_name} 시험지 보기',
    buy_code_tip: '이 쿠폰코드를 이메일로 보내드렸습니다. 이제 테스트할 {level_name} 시험지를 선택하고 쿠폰코드를 입력하여 잠금을 해제하세요.',
    discount_codes_left_tip: '테스트 종료 후, 현재 등급에서 <span style="color: #62C1A5;font-size: 16px;font-weight: 500;">{count}개의</span> 쿠폰코드가 남습니다.',
    manage_class: '학급 관리',
    to_manage_class: '학급 관리 시스템은 새 탭에서 열립니다. 완료되면 이 탭으로 돌아와 페이지를 새로 고쳐 주세요.',
    sso_login_signup: '**로그인 / 등록**',
    sso_email_address: '이메일 주소',
    sso_password: '비밀번호',
    sso_characters_long: '계정이 없으신가요? 6-20자 사이의 비밀번호를 설정해 주세요.',
    sso_forget_pw: '비밀번호 찾기',
    sso_agree_policy: '<u class="strong"><a href="{url}" target="_blank">《사용자 계약》</a></u> 및 <u class="strong"><a href="{userUrl}" target="_blank">《개인정보 보호정책》</a></u>을 읽고 동의했습니다.',
    sso_continue: '계속',
    sso_please_check: '《사용자 계약》과 《개인정보 보호정책》을 읽고 동의해 주세요.',
    sso_invalid_email_address: '잘못된 이메일 주소',
    sso_invalid_password: '비밀번호 형식 오류',
    sso_loading: '로딩 중',
    sso_mock_platform: '공식 모의시험 플랫폼',
    sso_home_proficiency_tests: '가장 인기 있는 중국어 능력 평가 시험 준비',
    sso_guardian_consent_error: '작업 실패',
    sso_forget_pw_success: '비밀번호 재설정 이메일 발송 성공',
    sso_forget_pw_error: '비밀번호 재설정 이메일 발송 실패',
    sso_log_in_error: '로그인 실패',
    sso_download_app_mobile: '더 나은 사용 경험을 위해, 데스크탑 버전에서hskmock.com을 방문하시거나 앱을 다운로드해 주세요.',
    sso_no_binding_info_tip: '귀하의 세부 정보를 가져올 수 없습니다.',
    sso_third_login_tip: '열고자 하는 웹사이트를 선택하세요.',
    sso_third_login_wohui: '중국어 배우기 사이트로 이동',
    sso_third_login_mock: 'HSK Mock으로 이동',
    sso_for_china: '중국 (.cn) 서비스',
    sso_for_international: '국제 (.com) 서비스',
    hsk_practice_num1: '정답',
    hsk_practice_num2: '문제 총 {totalNum} 문제',
    hsk_enter_next_segment_msg: '다음 단계로 진행하시겠습니까?',
    hsk_end_preview: '미리보기 종료',
    hsk_end_review: '리뷰 종료',
    hsk_link_test: '공식 모의시험을 클릭하세요',
    hsk_link_tips: '공식 모의시험지로 공식 인증서 받기',
    hsk_test_content: '시험 내용',
    hsk_test_minute: '분',
    hsk_about: '약',
    hsk_abbreviation: '줄이기 원함',
    hsk_determine_ans: '답안을 시작하시겠습니까?',
    hsk_determine_ans_tips: '답안을 시작한 후에는 원문을 다시 볼 수 없습니다.',
    no_data: '데이터가 없습니다',
    hsk_question_number: '문제 수',
    hsk_test_rate: '시험 비중',
    hsk_operation: '작업',
    hsk_skip: '건너뛰기',
    hsk_spend: '비용',
    hsk_cost: '비용',
    hsk_credit: '잔액',
    hsk_pay_successfully: '결제 성공',
    hsk_select_amount: '충전 금액 선택',
    change_lang_ok: '확인',
    change_lang_cancel: '취소',
    hint_player_loader_error: '오디오 재생 실패',
    test_release: '게시',
    test_off_shelf: '내리기',
    test_enable: '활성화',
    test_record: '모의시험 기록',
    test_finish_time: '완료 시간',
    test_confirm_use: '활성화 확인',
    test_confirm_off_shelf: '내리기 확인',
    test_has_on_shelf: '게시됨',
    test_un_release: '게시되지 않음',
    test_un_enable: '활성화되지 않음',
    test_max_score: '최고 점수',
    test_average_score: '평균 점수',
    test_min_score: '최저 점수',
    test_paper_office: '시험지가 내려졌습니다!',
    test_complete_introduce: '전체 설명',
    test_course_link: '공식 코스',
    test_about_down_load: '관련 다운로드',
    mark_answer_user: '답안자',
    mark_answer_time: '답안 시간',
    mark_correct_time: '채점 시간',
    mark_correct_ing: '채점 중',
    mark_report_tips: '참고: 쓰기 부분은 총점에 아직 포함되지 않았습니다. {markNumberDesc} 문제는 전문 평가자가 48시간 내에 채점을 완료하며, 완료 후 총점이 동기화됩니다. 완료되면 이메일로 알려 드리겠습니다.',
    mark_report_tips_hskk: '참고: 문제는 전문 평가자가 48시간 내에 채점을 완료하며, 완료 후 총점이 동기화됩니다. 완료되면 이메일로 알려 드리겠습니다.',
    mark_submit_btn: '채점 제출',
    mark_submit_tips: '채점을 제출하시겠습니까?',
    mark_correct_tips: '현재 시험지가 채점 중이므로, 반복 채점이 불가능합니다!',
    mark_correct_person: '수동 채점',
    search_user_message: '사용자 이름 검색',
    mark_answer: '답안',
    home_test_registration: '시험 접수',
    home_word_outline: '어휘 테스트',
    home_online_practice: '무료 샘플 시험지',
    home_test: '공식 모의시험',
    common_text_control_speed: '재생 속도',
    button_common_playback: '녹음 재생',
    common_text_file_error: '리소스 팩 다운로드 실패, 다시 시도해 주세요',
    common_text_none_network: '네트워크 불안정',
    button_common_start_over: '다시 시도',
    evaluating_tips_common: '녹음된 음성과 텍스트 내용이 크게 다릅니다. 다시 녹음해 주세요.',
    evaluate_common_training_remain: '남은 시간:',
    evaluate_common_training_readyRcord: '녹음 준비',
    evaluate_common_training_atleast: '녹음 길이는 1초 이상이어야 합니다.',
    evaluate_common_training_atleast2: '녹음 길이는 2초 이상이어야 합니다.',
    evaluate_common_training_evaluting: '채점 중',
    evaluating_tips_additionalAndBack: '녹음 중에 삽입/반복된 부분이 있어, 전체 점수에 영향을 미쳤습니다.',
    textbook_chioce_word_text_correct_tip: '정답입니다, 훌륭합니다!',
    textbook_chioce_word_text_error_tip: '오답입니다, 더 노력하세요!',
    textbook_reading_comprehension_stem: '독해',
    spc_back_tips: '연습을 종료하시겠습니까? 종료 후 현재 답안은 저장되지 않습니다.',
    spc_level_text: '레벨테스트',
    spc_capability_assessment: '능력 평가',
    spc_pick_level: '등급 선택',
    spc_listen: '듣기',
    spc_read: '독해',
    spc_write: '쓰기',
    spc_translation: '번역',
    spc_result_tips: '테스트 결과에 따르면, 귀하의 중국어 능력은 HSK 레벨{level}에 해당합니다.',
    spc_recommend_test: 'HSK {level} 급 준비를 권장합니다.',
    spc_recommend_test1: '<strong>HSK {level}</strong> 급 준비를 권장합니다.',
    spc_again_test: '다시 테스트',
    spc_where_tips: '내 중국어 레벨이 확실하지 않나요?',
    spc_immediate_test: '지금 테스트',
    spc_test_content_desc: '듣기, 말하기, 독해(낭독), 쓰기(수동 입력 또는 선택), 번역 다섯 가지 측면에서 학습자의 능력을 평가합니다. 등급별로 테스트 문제가 다릅니다.',
    spc_test_timer: '테스트 시간',
    spc_test_timer_desc: '약 15분 소요, 등급이 높을수록 소요 시간이 길어집니다.',
    spc_test_result: '테스트 결과',
    spc_test_result_desc: '빠른 등급 설정과 특정 스킬 향상을 돕습니다.',
    vocab_level_word: '{level}급 어휘',
    vocab_all_marked: '전체',
    delete_confirmation: '어휘 삭제 +D460:D501확인',
    cancel: '취소',
    del: '삭제',
    edit_vocab: '어휘 편집',
    add_vocab: '어휘 추가',
    hanzi: '한자',
    num_bihua: '획수',
    write_demo: '쓰기 시범',
    vocab_side: '부수',
    see_more: '더보기',
    same_read_word: '동음자',
    samilar_read_word: '유사음',
    add_mark: '표시 추가',
    word_team: '단어 조합',
    instance: '예문',
    include_num_char: '{total}개의 한자 포함',
    length_diff: '한자의 음과 길이가 일치하지 않습니다.',
    add_word_success: '어휘 추가 성공',
    add_word_fail: '어휘 추가 실패',
    edit_word_success: '어휘 편집 성공',
    edit_word_fail: '어휘 편집 실패',
    del_success: '삭제 성공',
    del_fail: '삭제 실패',
    mark_free: '마스터한 것으로 표시할 수 있습니다.',
    write_word_sentence: '위의 단어로 문장을 만들어 주세요…',
    write_word_artical: '위의 키워드로 단락을 작성해 주세요…',
    write_img_artical: '위의 이미지로 단락을 작성해 주세요…',
    write_artical_title: '기사 제목을 입력해 주세요…',
    write_artical_content: '본문을 입력해 주세요…',
    my_wallet: '내 구매 내역',
    manage: '사용자 관리',
    edit_info: '정보 편집',
    change_avatar: '프로필 사진 변경',
    preview_avatar: '프로필 사진 미리보기',
    upload_image: '이미지 업로드',
    change_image: '이미지 변경',
    enter_old_pw: '기존 비밀번호를 입력해 주세요',
    enter_new_pw: '새 비밀번호를 입력해 주세요',
    enter_new_pw_again: '새 비밀번호를 다시 입력해 주세요',
    recharge: '충전',
    left_balance: '사용할 수 있는 잔액',
    consume_log: '시험지 답안',
    consume_source: '지출한 비용',
    consume_money: '비용',
    total_item_log: '총 {total}건의 기록',
    recharge_time: '충전 시간',
    recharge_num: '충전 수량',
    recharge_money: '충전 금액',
    learn_content: '학습 내용',
    view_result: '성적 보기',
    gifted: '증정',
    old_password_empty: '이전 비밀번호는 비워둘 수 없습니다',
    diff_password: '입력한 두 비밀번호가 일치하지 않습니다',
    change_pw_success: '비밀번호 변경 성공',
    change_pw_fail: '비밀번호 변경 실패',
    change_info_success: '정보 수정 성공',
    change_info_fail: '정보 수정 실패',
    statistics_center: '통계 센터',
    select_recharge_mount: '충전 금액 선택',
    has_no_resolve_credit: '결제 신호를 받지 못했습니다. 다시 시도해 주세요.',
    complete_pay: '결제 완료',
    pay_fail: '결제 실패',
    give_success: '증정 성공',
    give_fail: '증정 실패',
    change_avatar_success: 'Avatar 변경 성공',
    change_avatar_fail: 'Avatar 변경 실패',
    enter_family_name: '성을 입력해 주세요',
    enter_given_name: '이름을 입력해 주세요',
    invalid_email_address: '잘못된 이메일 주소입니다',
    password_tip: '비밀번호 길이는 6-20자 사이여야 합니다',
    invalid_password: '비밀번호 형식 오류',
    have_account: '이미 {text} 계정이 있습니다',
    forget_pw_success: '비밀번호 재설정 메일 전송 성공',
    forget_pw_error: '비밀번호 재설정 메일 전송 실패',
    loading: '로딩 중',
    account_block: '계정 비활성화',
    account_block_tip: '추가 정보를 얻으려면 학교 관리자에게 문의하십시오',
    resend_email_success: '이메일이 다시 전송되었습니다',
    resend_email_error: '이메일 다시 전송 실패',
    i_am: '저는',
    choose_role: '가장 잘 설명할 수 있는 것을 선택해 주세요',
    choose_role_error: '역할 선택 실패',
    learner: '학생',
    learner_description: '저는 중국어를 배우고 있습니다',
    teacher_description: '저는 중국어를 가르치고 있습니다',
    setup_account_error: '계정 정보 설정 실패',
    email_verified_tip: '이메일 인증해 주셔서 감사합니다.',
    email_verified_error: '계정을 인증할 수 없습니다',
    something_wrong: '문제가 발생했습니다',
    retry: '다시 시도',
    guardian_consent_error: '작업 실패',
    download: '다운로드',
    submit: '제출',
    feedback_success: '제출 성공',
    feedback_error: '제출 실패',
    logout: '로그아웃',
    file_error: '파일 형식 또는 크기 오류',
    file_num_limit: '파일 업로드 최대 수량은{maxFiles}개입니다',
    privacy_policy_text1: 'HSK Mock.com — Hanban 공인 모의시험 플랫폼',
    privacy_policy_text2: '모의시험 플랫폼은 Wo Hui와 Hanban이HSK 및 YCT 문제은행을 기반으로 공동 개발 및 운영한 것입니다. 완전한 실전 모의시험 훈련을 제공하여 중국어 학습자의 표준화된 중국어 시험을 지원합니다.',
    privacy_policy_text3: 'Wo Hui Mandarin은 Hanban의 공식 파트너입니다.',
    privacy_policy_text4: 'Hanban Education Technology (Beijing) Co., Ltd.는 전문 국제 중국어 교육 시험 서비스 기관으로, 전 세계적으로 중국어 교육 및 시험 연구 디자인, 기술 개발, 시험 실행, 마케팅 등에 대한 전문 서비스를 제공하여 전 세계 중국어 학습자와 교육 기관의 요구를 최대한 충족시키고자 합니다.',
    privacy_policy_text5: 'Wo Hui는 2018년 싱가포르에서 EiM International Education Group에 의해 설립된 독립적인 회사로, 전 세계 중국어 학습자들에게 중국어 학습을 위한 기술 지원 및 플랫폼 서비스를 제공하는 것을 목표로 하고 있습니다. 다양한 학생들을 위해 다양한 코스를 제공하고, 교사들에게는 방대한 교육 자료와 실용적인 교육 도구를 제공합니다. 기술은 교육을 지원하고, 교사의 수고를 덜어주며, 교육 과정을 완성하여 학생들이 자신의 개별 목표를 달성하고 뛰어난 독립 학습자가 되도록 격려합니다.',
    privacy_policy_text6: 'Hanban과 Wo Hui는 좋은 협력 관계를 가지고 있으며, 중국어 학습의 보급과 발전을 위해 함께 노력하고 있습니다. 학생들의 레벨을 보다 정확하게 판단하고, 타겟 학습을 진행하며, 실제 시험 환경을 모의하기 위해 두 기관은 심층적인 전략적 협력을 진행하며, 중국어 학습자의 모든 학습 요구를 충족시키기 위해 전방위적으로 협력하고 있습니다.',
    level_test: '레벨테스트',
    level_test_example: '자신의 레벨을 확신하지 못하시면, 무료로 빠른 테스트를 한 번 받아보시고 어떤 레벨의 학습 목표를 설정하는 것이 적합한지 확인해 보세요.',
    download_app_mobile: '더 나은 사용 경험을 위해, hskmock.com에 데스크톱 버전으로 접속하거나 앱을 다운로드하여 사용해 주세요.',
    common_video_failed: '오디오 로드 실패',
    member_error: '리소스 이상 발생!',
    media_devices_unsupported_browserLabel: 'Google Chrome 브라우저를 기본 브라우저로 설정하는 것을 권장합니다. 설정 방법: Windows 10을 예로 들면, 설정 - 응용 프로그램 - 기본 응용 프로그램 - 웹 브라우저 - Google Chrome 선택',
    media_devices_help_title: '마이크를 켜시겠습니까?',
    media_devices_help_content: '오디오를 녹음하려면 마이크를 켜야 합니다',
    batch_from: '출처',
    batch_select: '선택해 주세요',
    common_to: '목적지',
    common_start_time: '시작 날짜',
    common_end_time: '종료 날짜',
    batch_name: '이름',
    select_country: '국적을 선택해 주세요',
    polyphonic: '다음 음절',
    download_tips: '합격 점수만 있으면 모의시험 증서를 다운로드할 수 있습니다',
    cancel_confirm: '확인',
    user_apply_delete_account_title: '계정 해지 신청',
    user_apply_delete_account_confirm_tip: '로그인 정보를 확인해 주세요',
    user_apply_delete_account_alwaysTip: '현재 모의고사 계정 및 관련 개인정보를 영구적으로 삭제하겠다고 요청했습니다.',
    user_apply_delete_account_confirm_tip2: '신청을 제출하기 전에 신분을 확인해 주세요.',
    user_apply_delete_account_desc: '귀하의 계정 {email}은 로그인 및 <a href="{wohuiLink}" target="_blank">Wo Hui Mandarin</a> 및 <a href="{mockLink}" target="_blank">HSK Mock</a> 사용에 사용됩니다',
    user_apply_delete_account_desc2: '계정이 해지되면 위의 응용 프로그램에 로그인할 수 없습니다.',
    user_apply_delete_account_wohui_title: 'Wo Hui 구독 취소',
    user_apply_delete_account_hsk_title: 'HSK MOCK 잔액',
    user_apply_delete_account_next_tip: '"다음" 버튼을클릭하면 위 내용을 읽고 동의했음을 확인합니다.',
    user_apply_delete_account_next_title: '다음',
    user_apply_delete_account_confirm_tip11: '구독을 취소한 후 계정 해지 요청을 완료하세요',
    cancel_delete_request_send: '요청 전송',
    user_apply_delete_account_confirm_tip8: '구독이 {date}에 만료되면 귀하의 계정은 영구 삭제됩니다',
    user_apply_delete_account_confirm_tip4: '다음 주소로 이메일을 보냅니다.',
    user_apply_delete_account_confirm_tip5: '계정이 삭제되었는지 확인하기 위해',
    user_apply_delete_account_confirm_tip6: '취소하려면"취소" 버튼을 클릭하십시오',
    user_apply_delete_data_always: '모의고사 계정 및 관련 개인정보의 영구 삭제 요청을 취소하시겠습니까?',
    cancel_delete_yes: '확인',
    cancel_delete_no: '취소',
    user_cancel_delete_success: '요청이 취소되었으며, 귀하의 HSK Mock 계정은 해지되지 않습니다.',
    user_cancel_subscribe_again: '다시 구독할 수 있습니다.',
    user_apply_delete_account_confirm_tip9: '귀하의 구독 만료일은',
    user_apply_delete_account_confirm_tip10: '계정을 해지하고자 하는 시간을 선택해 주세요',
    user_apply_delete_account_ok_btn_title: '구독 만료 시',
    user_apply_delete_account_now_btn_title: '즉시 해지',
    cancel_out_subscription_abnormal: '사용자 구독 정보 이상',
    user_apply_delete_account_confirm_tip3: 'Apple에 구독이 있으며, 자동으로 요금이 청구되므로 갱신 전에 Apple 구독을 취소하십시오',
    user_apply_delete_stripe_tip: 'Stripe 구독은 귀하의 신용카드/직불카드를 통해 자동으로 요금이 청구됩니다. 웹사이트를 방문해 주세요.',
    user_apply_delete_account_balance: '귀하의 계정 잔액은',
    user_apply_delete_account_balance_tip: '계정 해지 후 잔액은 반환되지 않습니다.',
    user_apply_delete_account_expire: '귀하의 계정은 3일 내에 해지됩니다',
    my_class_search: '수업 검색',
    my_class_people: '명',
    my_class_ci: '연인원',
    my_class_number: '인원수',
    my_class_ci_number: '횟수',
    my_class_tips: '내부 고리: HSK 및 YCT 분포 비율',
    my_class_tips1: '외부 고리: HSK 및 YCT 각 레벨 분포 비율',
    follow_lesson: '수업 보기',
    real_paper: '모의시험 진행',
    start_answer: '시험 시작',
    select_currency_tips: '원하는 경우, 아래 드롭다운 목록에서 다른 통화를 선택할 수 있습니다.',
    change_currency_tips: '“내 계정”에서 언제든지 선호하는 통화를 변경할 수 있습니다.',
    my_homework: '내 과제',
    my_homework_add: '과제 배정',
    my_homework_all_classes: '모든 수업',
    my_homework_sent_to: '전송',
    my_homework_sent_on: '전송 시간',
    my_homework_submitted_assignees: '제출 인원/발송 인원',
    my_homework_class_hint: '수업 이름 주변의 아이콘은 일부 학생에게만 배정된 것을 나타냅니다',
    my_homework_add_send_assignment: '과제 전송',
    my_homework_add_new_assignment: '새 과제',
    my_homework_edit_assignment: '과제 편집',
    my_homework_add_assignment: '과제 추가',
    my_homework_add_assignment_details: '1. 과제 세부 정보',
    my_homework_add_issue_time: '게시 시간',
    my_homework_add_whether_submit: '기한 후 제출 허용',
    my_homework_add_assignees: '2. 전송 대상',
    my_homework_edit_add_assignees: '전송 대상',
    my_homework_add_group: '수업 선택',
    my_homework_add_immediate_release: '즉시 게시',
    my_homework_add_time_release: '예약 게시',
    my_homework_add_are: '예',
    my_homework_add_no: '아니요',
    my_homework_detail_back: '내 과제로 돌아가기',
    my_homework_detail_sent_to: '에게 전송',
    my_homework_detail_leamers_in: '명 학생에게',
    my_homework_detail_on: '에서',
    my_homework_detail_to_complete_by: '에서 전송 완료',
    my_homework_detail_add_assignee: '전송 대상 추가',
    my_homework_detail_assignee: '전송 대상',
    my_homework_search_placeholder: '검색 내용을 입력해 주세요',
    my_homework_total_topic_count: '총 {count}문제',
    my_homework_select_date_time: '날짜 및 시간 선택',
    my_homework_delete_assignment_title: '과제 삭제',
    my_homework_delete_assignment_tips: '과제를 삭제하시겠습니까? 삭제 후 취소할 수 없습니다!',
    my_homework_assignment_add_fail: '게시 실패!',
    my_homework_assignment_add_success: '게시 성공!',
    my_homework_assignment_edit_success: '편집 성공!',
    my_homework_assignment_edit_fail: '편집 실패!',
    my_homework_assignment_delete_fail: '삭제 실패!',
    my_homework_assignment_delete_success: '삭제 성공!',
    my_homework_assignment_due_on: '기한',
    my_homework_assignment_product: '상품 이름',
    my_homework_assignment_reset: '초기화',
    my_homework_assignment_reset_title: '선택한 모듈을 초기화하시겠습니까?',
    my_homework_assignment_gifted: '증정 수량',
    my_homework_assignment_papers: '장 시험지',
    my_homework_assignment_send_to: '과제 전송처',
    my_homework_assignment_close_tip: '현재 과제가 저장되지 않았습니다. 종료하시겠습니까?',
    no_available_class: '선택할 수 있는 학급이 없습니다',
    payment_method: '결제 방법',
    wechat_pay: '위챗 페이',
    alipay_payment: '알리페이',
    card_payment: '신용카드 결제',
    card_payment_description: '해외 카드 전용',
    payment_to_wohui: 'Wo Hui Wo Hui Wo Hui Technology (Shanghai) Co., Ltd.로결제',
    order_submitted: '주문이 성공적으로 제출되었습니다. 신속히 결제해 주세요!',
    order_number: '주문 번호:',
    code_expires: 'QR 코드 만료까지 남은 시간 <span style="color: #fc5a5a;font-size: 16px;font-weight: 500;">{time}</span>',
    use_weChat: '위챗 스캔으로 결제해 주세요',
    code_expired: '현재 QR 코드가 만료되었습니다',
    amount_payable: '결제 금액:',
    level_HSK_text1: '<b>HSK</b>는 "중국어 능력 시험"의 약자로, 중국어 능력 테스트를 의미합니다.',
    level_HSK_text2: '전 세계에서 가장 인기 있는 중국어 능력 평가 시험입니다.',
    level_YCT_text1: '<b>YCT</b>는 "청소년 중국어 능력평가 시험"의 약자로,',
    level_YCT_text2: '청소년을 위한 중국어 능력 테스트를 의미합니다.',
    level_dialog_title: '레벨 테스트',
    level_dialog_login: '로그인/회원가입',
    restart: '재시작',
    candidates_proficiency_speaking: '이 시험은 응시자의 중국어 말하기 능력을 테스트합니다.',
    currency_type: '통화 선택',
    test_session: '번 테스트',
    On: '에',
    Level_test: '레벨 테스트',
    start_assigment: '시작',
    view_assigment: '결과 보기',
    continue_assigment: '계속',
    browser_layer: 'PC에서 Google Chrome 브라우저를 사용하거나 모바일 기기에서 APP를 사용하십시오.',
    submit_success: '전송 성공',
    hsk_confidence: 'HSK 시험에 합격할 자신감이 생겼습니다',
    for_teachers: '교사',
    hsk_submit_reading: '독해',
    download_certificate: '증명서 다운로드',
    create_certificate: '증명서 생성',
    certificate_is_downloaded: '증명서가 다운로드되었습니다',
    total: '총계',
    pay: '결제',
    test_count: '{test_num}번 테스트',
    history_purchase_quantity: '수량',
    hsk_listen_part_title: '듣기 {count}부',
    hsk_read_part_title: '독해 {count}부',
    hsk_write_part_title: '쓰기 {count}부',
    Description: '소개',
    Test_format: '시험 형식',
    Vocabulary: '어휘',
    other_gender: '기밀/기타',
    hsk_enter_listening: '듣기',
    hsk_enter_next_segment_preview: '미리 보기를 종료하시겠습니까? 미리 보기 종료 후, 듣기시험이 시작됩니다.',
    hsk_enter_next_segment_listen_tip: '듣기 문제 {count}문제를 아직 답하지 않았습니다,',
    hsk_enter_next_segment_listen: '듣기 부분 제출하시겠습니까? 제출 후, 듣기 부분이 종료됩니다.',
    hsk_enter_next_segment_listen_review_start: '지금은 듣기 부분 검토 시간이며, {count}분 동안 듣기 문제의 답안을 확인할 수 있습니다.',
    hsk_enter_next_segment_listen_review: '듣기 부분 검토를 종료하시겠습니까? 듣기 검토 종료 후, 독해 시험이 시작됩니다.',
    hsk_enter_next_segment_read_tip: '독해 문제 {count}문제를 아직 답하지 않았습니다,',
    hsk_enter_next_segment_read: '독해 부분을 제출하시겠습니까? 제출 후, 독해 부분이 종료되며, 수정할 수 없습니다.',
    hsk_enter_next_segment_write_tip: '쓰기 문제 {count}문제를 아직 답하지 않았습니다,',
    hsk_enter_next_segment_write: '시험지를 제출하시겠습니까?',
    intro_msg_first: '이번 시험은 총 {num}개 부분으로 구성되어 있으며, 각 부분을 순차적으로 완료해야 합니다.',
    intro_msg_second: '정해진 시간 내에 각 부분의 문제를 완료해 주세요.',
    intro_msg_third: '이 부분의 문제를 이미 완료했지만 종료 시간이 지나지 않은 경우, 시험지의 다음 부분으로 이동할 수 있지만, 이전 부분으로 돌아가서 답안을 수정할 수 없습니다.',
    dialogue_listening: '첫 번째 부분은 듣기시험입니다. 아래의 테스트 오디오를 재생 버튼을 클릭하고 필요에 따라 장치를 조정해 주세요.',
    dialogue_listening_hskk: '아래의 테스트 오디오를 재생 버튼을 클릭하고 필요에 따라 장치를 조정해 주세요.',
    dialogue_intro_msg_first: '음악이 재생되는 동안 시험 전반에 대한 내용을 파악할 수 있습니다. 이 소개가 재생되는 동안 듣기 부분의 문제를 미리 볼 수 있습니다.',
    dialogue_intro_msg_first_hskk: '음악이 재생될 때, 시험의 전체적인 소개가 따라옵니다.',
    dialogue_intro_msg_second: '실제 시험을 시뮬레이션하기 위해 듣기 부분의 오디오를 일시 정지, 다시 재생 또는 빠르게 넘길 수 없습니다.',
    dialogue_intro_msg_second_hskk: '실제 시험을 모의하기 위해, 일시 정지, 재생 또는 빨리 감기를 할 수 없습니다.',
    dialogue_intro_msg_third: '듣기 부분의 오디오가 끝난 후, 답안을 검토할 수 있는 {duration}분의 시간이 주어집니다.',
    dialogue_intro_question: '문제가 발생했나요?',
    dialogue_preload_intro_first: '듣기 부분의 오디오를 다운로드 중입니다.',
    dialogue_preload_intro_second: '다운로드가 완료되면 오디오가 자동으로 재생되어 시험이 시작됩니다.',
    dialogue_preload_intro_third: 'Good luck!',
    dialogue_preload_title: '시험 리소스를 다운로드 중입니다',
    mock_paper_preview: '모의시험 미리 보기',
    dialogue_mock_paper_intro_title: '시험 안내',
    dialogue_mock_paper_intro_sentence1: '이번 시험은 약 {minutes}분이 소요됩니다. 시험을 한 번에 완료할 수 있는 충분한 시간과 배터리를 확보해 주세요.',
    dialogue_mock_paper_intro_sentence2: '이번 시험은 온라인으로 진행되므로, 안정적인 네트워크 연결을 확인해 주세요.',
    dialogue_mock_paper_intro_sentence3: '데스크탑 컴퓨터나 노트북을 사용하는 경우, 최신 버전의Chrome 또는 Safari 웹 브라우저를 사용해 주세요.',
    dialogue_mock_paper_intro_sentence4: '태블릿을 사용하는 경우, 웹 브라우저가 아닌 모바일 애플리케이션을 사용해 주세요.',
    dialogue_mock_paper_intro_sentence5: '시험 중에는 다른 브라우저 창이나 모바일 애플리케이션을 열지 마시고, 언어를 변경하거나 다른 장치(USB, 헤드폰 등)를 삽입/제거하지 마세요.',
    diologue_mock_paper_quit: '종료',
    dialogue_mock_paper_intro_button: '읽고 이해했습니다',
    vocab_type: '품사',
    deadline_passed: '마감일이 지났습니다',
    mock_skip_introduction: '설명을 건너뛰시겠습니까?',
    edit_message_date: '날짜',
    edit_message_language: '언어',
    edit_message_zh: '중국어',
    edit_message_en: '영어',
    edit_message_title: '제목',
    edit_message_content: '본문을 입력해 주세요',
    edit_message_show: '표시',
    edit_message_save_success: '저장 성공!',
    edit_message_create_success: '추가 성공!',
    edit_message_edit1: '편집',
    edit_message_follow_notice: '알림 보기',
    edit_message_textarea_tips: '링크를 추가하는 경우, 링크 뒤에 공백을 추가해 구분해 주세요',
    edit_message_notifications: '알림 편집',
    edit_message_edit_notification: '알림 편집',
    edit_message_add: '알림 추가',
    edit_message_from: '시작 시간',
    edit_message_to: '종료 시간',
    edit_message_new_add: '알림 추가',
    mark_correct_status: '채점 상태',
    mark_correct_user: '채점자',
    mark_correct_option: '작업',
    mark_un_correct: '채점하지 않음',
    mark_has_correct: '채점 완료',
    mark_current_user: '현재 사용자',
    mark_correct_paper: '채점',
    mark_all_status: '모든 상태',
    mark_all_level: '모든 등급',
    mark_overtime: '시간 초과',
    hsk_if_save: '모의시험을 종료하시겠습니까? 종료 후 답안 기록이 보존되며, 다음 번에 들어와서 이 모듈을 계속 풀 수 있습니다.',
    hsk_if_test: '지난번 시험이 종료되지 않았습니다, 계속 시험을 진행하시겠습니까?',
    hsk_start_again: '시험 재응시 하기',
    Listening: '듣기',
    Reading: '독해',
    Writing: '쓰기',
    hsk_example_eg: '예제',
    hsk_test_again: '다시 시도',
    opera_person: '조작자',
    hsk_reference_answer: '모범 답안:',
    hsk_reference_answer_hskk: '문제 음성 내용:',
    hsk_homework_no_answer: '미답',
    hsk_practice_check: '보기',
    personal_info_display_name_as: '증명서 표시 이름',
    code_pratice_text: ' <span style="font-weight: 600;color: #0C0C0C"> {paper_name} </span> 을(를) 사용하여  <span style="font-weight: 600;color: #0C0C0C"> {level_name} </span>  모의 시험을 치르세요.',
    code_input_text: '쿠폰코드를 입력해 주세요',
    use_code_limit: '각 Code는 한 번만 사용할 수 있습니다',
    code_select_text: '또는 쿠폰코드를 선택해 주세요',
    pay_discounts_desc1: '이전 시험 문제의 연습을 통해,',
    pay_discounts_desc2: '[{type}] [{level}] 시험에서 최고의 성적을 거둘 수 있습니다',
    pay_discounts_desc3: '1+1 혜택',
    pay_discounts_desc4: '이미 [{type} {level}] 정식 시험에 등록하셨다면, [{type} {level}] 모의시험지를 구매할 때 1+1 혜택을 받을 수 있습니다.',
    pay_discounts_desc5: '몇 개의 모의시험지를 구매하시겠습니까?',
    level_HSKK_text1: 'HSK 말하기 시험은 수험자의 중국어 말하기 능력을 평가합니다. 이 시험은 초급, 중급, 고급 세 개의 레벨로 구성되어 있습니다.',
    level_HSKK_text2: 'HSK 말하기 시험은 녹음 형식으로 진행됩니다.',
    level_HSKK_text3: 'HSK 3급 수험자는 HSKK 초급 레벨 시험을 통과해야 하고, HSK 4급 수험자는 HSKK 중급 레벨 시험을 통과해야 하며, HSK 5급과 6급 수험자는 HSKK 고급 레벨 시험을 통과해야 합니다.',
    test_download_desc: '이 등급의 모의시험지가 준비 중입니다. 동시에, 아래를 다운로드해 주세요:',
    speaking: '말하기',
    meaning: '번역',
    Traduction: '번역',
    my_homework_none_homework: '이 등급은 현재 모의시험지를 제공하지 않습니다. 기대해 주세요.',
    my_class_none_test: '이 등급은 현재 온라인 모의시험 문제 풀이를 지원하지 않습니다. 기대해 주세요.',
    sso_join_campus_text1: '로그인 또는 가입하여 중국어 교육, 학습, 모의시험, 평가 커뮤니티에 참여하세요:',
    sso_join_campus_text3: '커뮤니티의 교사는 HSKMock.com에서 시험지를 배정해 줄 수 있으며, app.wohuimandarin.com에서연습 문제를 배정할 수 있습니다.',
    sso_join_campus_text4: '교사는 여러분의 답안을 확인하여 맞춤형 피드백을 제공할 수 있습니다.',
    mock_join_campus_text1: '이 중국어 교육, 학습, 모의시험, 평가 커뮤니티에 가입하시겠습니까?',
    mock_join_campus_text2: '커뮤니티에 가입하면, 교사는 HSKMock.com에서 시험지를 배정해 주거나 app.wohuimandarin.com에서 연습 문제를 배정할 수 있습니다.',
    hsk_audio_error: '현재 네트워크 환경이 불안정하여 오디오 로드에 실패했습니다. 다시 시도해 주세요.',
    free_practice_title: '무료 연습',
    choose_free_practice: '연습 방법 선택',
    word_flashcards: '단어 플래시 카드',
    word_practice: '단어 연습',
    analyse_text: '텍스트 분석',
    flashcards_title: '플래시 카드',
    practice_exercises_title: '연습 문제',
    analyse_title: '분석',
    practice_result_title: '연습 결과',
    generate_flashcards: '플래시 카드 세트 생성',
    generate_practice: '연습 문제 세트 생성',
    random_select: '랜덤 선택',
    manual_select: '수동 선택',
    max_words: '최대{number} 개의 단어',
    already_choose: '선택됨: {total} 개',
    free_practice_unchoose_question: '문제 유형을 선택해 주세요',
    free_practice_unchoose_practice: '연습 유형을 선택해 주세요',
    none_mark_words_hint: '현재 레벨에서 아직 표시되지 않은 단어들',
    excceed_max_count: '최대 {total}개의 단어를 선택할 수 있으며, 최대치에 도달했습니다.',
    free_practice_sound: '소리',
    free_practice_question: '문제',
    free_practice_choose_exercise: '연습 유형 선택',
    free_practice_exercise_select: '단일 선택',
    free_practice_exercise_Pairs: '매칭',
    free_practice_exercise_TF: '바른 것(T)과 틀린 것(F)을 선택합니다',
    launch: '시작',
    free_practice_check_text: '정답을 맞추셨나요?',
    free_practice_timer_pause: '타이머 일시 정지',
    free_practice_timer_pause_desc: '조작이 감지되지 않으면 타이머가 자동으로 일시 정지됩니다.',
    free_practice_seconds: '{number}초',
    resume: '다시 시작',
    flashcard_completed: '플래시 카드 완료',
    practice_completed: '연습 완료',
    practice_spent_minutes: '총 시간: {duration}분',
    practice_result_summary: '결과 요약',
    practice_result_progress_txt: '당신의 점수',
    practice_wrong: '오답',
    practice_skip: '건너뛰기',
    practice_done: '완료',
    analyse_desc_1: '텍스트에 선택된 단어 분석',
    analyse_desc_2: '중국어 텍스트를 붙여넣거나 입력하세요(최대 {maxCount}자)',
    analyse_input_placeholder: '중국어 텍스트 입력',
    free_practice_need_word: '표에서 단어를 선택하거나 랜덤 단어 생성을 선택하세요',
    free_practice_exercise_select_title: '정답을 선택하세요',
    free_practice_exercise_pairs_title: '클릭하여 매칭하기',
    free_practice_exercise_meaning_title: '다음으로 번역되어야 합니다',
    free_practice_exercise_sound_title: '다음으로 읽어야 합니다',
    free_practice_exercise_characters_title: '다음으로 작성되어야 합니다',
    free_practice_show_correct_answers: '정답 보기',
    free_practice_check: '확인',
    free_practice_correct:'정답',
    free_practice_characters:'단어',
    free_practice_show_my_answers: '내 답안 보기',
    hsk_introduce_objective_questions: '객관적 문제',
    hsk_introduce_subjective_questions: '주관적 문제',
    hsk_input_type_here: '여기에 입력',
    hsk_translation_part_title: '번역, 부분 {count}',
    hsk_speaking_part_title: '말하기, 부분 {count}',
    subjective_reading_placeholder: '상술한 문장에 근거하여 질문에 대답해 주십시오...',
    hsk_write_by_artical: '상술한 자료에 근거하여 글을 한 편 쓰십시오...',
    hsk_translation_by_artical: '상술한 자료에 근거하여 번역해 주십시오...',
    hsk_trasnlation_choose_language: '다음은 번역 부분입니다.언어를 선택하십시오.',
    choose_speaker: '스피커를 선택합니다.',
    choose_microphone: '마이크를 선택합니다.',
    hsk_is_recording: '녹화 중입니다.',
    dialogue_speaking: '마지막 부분은 연설 부분이다.장치의 스피커와 마이크가 제대로 작동하는지 확인하십시오.',
    start_recording: '를 클릭하여 기록을 시작합니다.',
    hsk_write_count: '인물',
    error_access_media: '미디어 장치에 액세스하는 중 오류가 발생했습니다.',
    setSinkId_not_supported: '브라우저에서 {setSinkId}을(를) 지원하지 않습니다.',
    error_switch_device: '디바이스를 전환하는 동안 오류가 발생했습니다.',
    translation_section: '번역 영역',
    speaking_section: '구어 영역',
    failed_upload_record: '녹음 오디오 업로드가 실패했습니다. 다시 업로드를 클릭하십시오.',
    hsk_enter_next_segment_write_high: '글쓰기 섹션을 제출하시겠습니까?커밋한 후에는 수정을 위해 반환할 수 없습니다.',
    hsk_enter_next_segment_translate_tip: '너는 {count} 개의 번역 문제를 아직 풀지 못했다.',
    hsk_enter_next_segment_translate: '번역 섹션을 제출하시겠습니까?커밋한 후에는 수정을 위해 반환할 수 없습니다.',
    hsk_enter_next_segment_speaking_tip: '너는 {count} 개의 구어 문제를 아직 풀지 못했다.',
    batch_search_tips: '在此处粘贴用户帐号（请用逗号分隔，一次最多可以导入 50 个用户）',
    batch_search: '검색',
    give_history: '赠送历史',
    Speaking: '말하기',
    Translating: '번역',


    mock_tests: '모의고사',
    more_menu: '자세히 알아보기',
    support: '도움말 및 지원',
    blog_and_faq: '블로그 & 자주 묻는 질문',
    for_institutions: '학교 및 각종 교육 단체',
    tofficial_platform_new: 'HSK 공식 모의고사 플랫폼',
    proficiency_tests_new: '실제 시험지, 전문 채점, 어휘 강화, 스마트 연습 기능을 통합하여 효율적인 시험 대비를 지원합니다.',
    start_practicing: '연습 시작하기',
    get_ready: 'HSK 시험 대비, 지금 시작하세요!',
    real_hsk_exam_content: '실제 시험지',
    real_hsk_exam_desc: '실제 시험지로 연습하여 효율적으로 대비하고 자신감 있게 시험에 임하세요.',
    official_level_scoring: '전문 채점',
    official_level_scoring_desc: 'HSK 공식 기준에 따라 채점되어, 결과가 신뢰할 수 있습니다.',
    vocabulary_boost: '어휘 강화',
    vocabulary_boost_desc: '무료 어휘 카드 및 스마트 연습 도구를 활용하여 모든 어휘를 쉽게 암기하세요!',
    get_hsk_ready: '시험 준비 시작하기',
    how_it_works: '사용 방법',
    choose_your_level: '단계 선택',
    choose_your_level_desc: 'HSK 1급부터 9급까지, 자신의 수준에 맞는 시험 단계를 선택하세요.',
    practise_and_learn: '학습 및 평가',
    practise_and_learn_desc: '무료 어휘 훈련으로 시작하세요! 계정을 업그레이드하면 전체 HSK 공식 모의고사와 스마트 채점 서비스를 이용할 수 있습니다.',
    track_your_progress: '학습 진도 추적',
    track_your_progress_desc: '테스트 후 각 영역의 점수를 확인하고, 향상 방향을 파악해 효율적으로 학습 계획을 세울 수 있습니다.',
    get_started_new: '지금 시작하세요',
    real_results_from_real_learners: '진짜 피드백, 진짜 성과',
    start_learning: '지금 바로 학습을 시작하세요!',
    on_the_move_new: 'HSK Mock 앱을 다운로드하여 ',
    download_mobile_new: '언제 어디서나 시험 대비가 가능합니다.',
    got_questions: '궁금한 점이 있으신가요? 저희가 도와드립니다.',
    faq: '자주 묻는 질문',
    faq_desc: 'HSK 시험 준비 및 HSK Mock 플랫폼 관련 FAQ',
    faq_btn: '자주 묻는 질문 보기',
    blog: '블로그',
    blog_desc: 'HSK 시험 준비 꿀팁과 정보 제공',
    blog_btn: '블로그 보기',
    contact: '문의하기',
    contact_desc: '개인 맞춤형 도움이 필요하신가요? 고객센터로 문의주세요.',
    contact_btn: '문의하기',
    footer: 'HSK Mock는 HSK 공식 모의고사 플랫폼입니다 실제 시험지, 전문 채점, 어휘 강화, 스마트 연습을 통합하여 효율적인 학습을 도와드립니다.',
    choose_your_hsk_level: 'HSK 등급 선택하기',
    choose_your_hsk_level_desc: 'HSK, HSK 말하기, YCT 대비를 위한 공식 모의고사와 스마트 도구를 활용해보세요',
    hsk_levels: 'HSK',
    hsk_speaking: 'HSK 말하기',
    yct: 'YCT',
    level_des: '시험 수준을 잘 모르겠다면? <b style="color: #000;cursor: pointer;font-weight: 700;" class="clickable">무료 수준 테스트를 진행해보세요 ></b>',
    about_us_new: '회사 소개',

    back_to_home: '홈페이지로 돌아가기',
    about_us_desc:
      '<b>HSK Mock</b>는 <b>HSK</b>, <b>HSK 말하기</b>, <b>YCT</b> 시험을 위한 공식 온라인 모의고사 플랫폼입니다.실제 시험 환경을 정밀하게 재현하여 학습자가 자신감을 가지고 시험에 대비하고, 정확한 평가를 통해 전반적인 실력을 향상할 수 있도록 도와드립니다.',
    who_we_are: '저희는 누구인가요?',
    who_we_are_desc:
      'HSK Mock는 <b>한고국제(Chinese Testing International)</b> 와 <b>Wo Hui Mandarin(我会中文)</b> 이 공동으로 개발한 플랫폼으로, 전 세계 중국어 학습자에게 공신력 있는 모의고사 및 학습 도구를 제공합니다.',
    why_choose_hsk_mock: '왜 HSK Mock를 선택해야 하나요?',
    about_us_carousel_1: '공식 모의고사 제공',
    about_us_carousel_1_content:
      'HSK, HSK 말하기, YCT 공식 시험 유형과 구조를 철저히 반영한 시험지를 제공합니다.',
    about_us_carousel_2: '공신력 있는 채점 체계',
    about_us_carousel_2_content:
      '정식 시험과 동일한 기준으로 채점하여 실력을 정확히 평가합니다.',
    about_us_carousel_3: '효율적인 학습 도구',
    about_us_carousel_3_content:
      '각 급수별 어휘 연습 등 상호작용형 기능을 통해 듣기, 말하기, 읽기, 쓰기 능력을 종합적으로 향상시킵니다.',
    about_us_carousel_4: '멀티 디바이스 지원',
    about_us_carousel_4_content: '컴퓨터와 모바일 모두 지원되어 언제 어디서나 자유롭게 연습할 수 있습니다.',
    about_us_carousel_5: '전 세계 학습자의 선택',
    about_us_carousel_5_content: 'HSK Mock는 이미 전 세계 수많은 학습자들이 목표를 달성할 수 있도록 돕고 있습니다.',
}
